module.exports = __webpack_public_path__ + "media/images/icons/outlined/small-dash-5ddd209c7243d721333af3c2acfd92c5.svg";